import React from 'react';

export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 20 32"
  >
    <g transform="translate(1 1)">
      <rect x="2.7" y="29.8" width="12.6" height="1" />
      <path d="M9,12.8c-1.7,0-3-1.6-3-3.5s1.3-3.5,3-3.5s3,1.6,3,3.5S10.7,12.8,9,12.8L9,12.8z" />
      <path
        d="M9,26.5l-0.4-0.4C8.3,25.7-0.5,15.8-0.5,8.9c0-5.3,4.3-9.6,9.5-9.6s9.5,4.3,9.5,9.6c0,6.9-8.8,16.8-9.1,17.2
			L9,26.5z M9,0.2c-4.7,0-8.5,3.9-8.5,8.6C0.5,14.6,7.3,23,9,25c1.7-2,8.5-10.4,8.5-16.1C17.5,4.1,13.7,0.2,9,0.2z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/tour/assets/onboarding/PinSvg.js